import { ColumnName, ColumnRank, ColumnNoc, ColumnHorse, ColumnAthleteHorse, ColumnStartOrder, ColumnExpander, ColumnExtendedResult, ColumnQualification} from "components/common/TableColumns"
import { ColumnHorseIcons, ColumnIrmOrExtendedResult } from "./TableColumns";

export function JumpingColumns() {
    return [
        ColumnStartOrder({}),
        ColumnRank({hasRankEqual:true}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnAthleteHorse({}),
        ColumnHorse({}),
        ColumnIrmOrExtendedResult({id:'TotalPenalties', code:'J_TOTAL_PEN', label: "HeaderTotalPenalties"}),
        ColumnExtendedResult({id:'Time', code:'J_TIME', label: "HeaderTime"}),
        ColumnQualification({className: 'text-end fw-bold'}),
        ColumnExpander({})
    ];
}

export function JumpingTeamsColumns() {
    return [
        ColumnStartOrder({}),
        ColumnRank({hasRankEqual:true}),
        ColumnNoc({}),
        ColumnName({}),
        ColumnHorseIcons({}),
        ColumnIrmOrExtendedResult({id:'TotalPenalties', code:'J_TOTAL_PEN', label: "HeaderTotalPenalties"}),
        ColumnExtendedResult({id:'Time', code:'J_TIME', label: "HeaderTime"}),
        ColumnQualification({className: 'text-end fw-bold'}),
        ColumnExpander({})
    ];
}


